import React from "react";
import { Typography, Tooltip, ThemeProvider, createTheme } from "@mui/material";
import PropTypes from "prop-types";
import { FontFamily, FontSize } from "./fontFamily";
const CustomText = ({
  colorvalue,
  variantvalue,
  componentvalue,
  desc = "",
  style,
  regular,
  bold,
  italic,
  semibold,
  h1,
  h2,
  title,
  title1,
  title4,
  title5,
  title6,
  title7,
  h3,
  h4,
  h5,
  p1,
  p2,
  h0,
  p3,
  small,
  p4,
  keyvalue,
  title2,
  nine,
  eight,
  seven,
  six,
  allowTooltip = false,
  tooltipLength = 15,
  eleven,
  normal,
  medium,
  noWrap = false,
  fontWeight = 0,
  fontFamily,
  className,
  title3,
}) => {
  const theme = createTheme({
    typography: {
      fontFamily: fontFamily,
      fontWeight: fontWeight,
    },
  });
  let open = (allowTooltip && desc?.length) < tooltipLength;
  return (
    <Tooltip disableHoverListener={open} title={desc}>
      <ThemeProvider theme={theme}>
        <Typography
          className={className}
          noWrap={noWrap}
          fontWeight={fontWeight}
          key={keyvalue}
          variant={variantvalue}
          component={componentvalue}
          sx={[
            style,
            {},
            medium && { fontFamily: FontFamily.Medium },
            normal && { fontFamily: FontFamily.Normal },
            regular && { fontFamily: FontFamily.Regular },
            semibold && { fontFamily: FontFamily.SemiBold },
            bold && { fontFamily: FontFamily.Bold },
            italic && { fontFamily: FontFamily.Italic },
            h0 && { fontSize: FontSize.h0 },
            h1 && { fontSize: FontSize.h1 },
            h2 && { fontSize: FontSize.h2 },
            title && { fontSize: FontSize.title },
            title1 && { fontSize: FontSize.title1 },
            title4 && { fontSize: FontSize.title4 },
            title5 && { fontSize: FontSize.title5 },
            title6 && { fontSize: FontSize.title6 },
            title2 && { fontSize: FontSize.title2 },
            title3 && { fontSize: FontSize.title3 },
            title7 && { fontSize: FontSize.title7 },
            h3 && { fontSize: FontSize.h3 },
            h4 && { fontSize: FontSize.h4 },
            h5 && { fontSize: FontSize.h5 },
            p1 && { fontSize: FontSize.p1 },
            p2 && { fontSize: FontSize.p2 },
            p3 && { fontSize: FontSize.p3 },
            p4 && { fontSize: FontSize.p4 },
            small && { fontSize: FontSize.small },
            eleven && { fontSize: FontSize.eleven },
            nine && { fontSize: FontSize.nine },
            eight && { fontSize: FontSize.eight },
            seven && { fontSize: FontSize.seven },
            six && { fontSize: FontSize.six },
          ]}
          color={colorvalue}
        >
          {desc}
        </Typography>
      </ThemeProvider>
    </Tooltip>
  );
};

CustomText.propTypes = {
  colorvalue: PropTypes.string,
  variantvalue: PropTypes.string,
  componentvalue: PropTypes.string,
  desc: PropTypes.string,
  style: PropTypes.object,
  regular: PropTypes.bool,
  bold: PropTypes.bool,
  italic: PropTypes.bool,
  semibold: PropTypes.bool,
  h1: PropTypes.bool,
  h2: PropTypes.bool,
  title: PropTypes.bool,
  title1: PropTypes.bool,
  h3: PropTypes.bool,
  h4: PropTypes.bool,
  h5: PropTypes.bool,
  p1: PropTypes.bool,
  p2: PropTypes.bool,
  p3: PropTypes.bool,
  small: PropTypes.bool,
  p4: PropTypes.bool,
  keyvalue: PropTypes.string,
  title2: PropTypes.bool,
  nine: PropTypes.any,
  eight: PropTypes.any,
  seven: PropTypes.any,
  six: PropTypes.any,
  allowTooltip: PropTypes.bool,
  tooltipLength: PropTypes.number,
  eleven: PropTypes.any,
  normal: PropTypes.any,
  medium: PropTypes.any,
  noWrap: PropTypes.bool,
  h0: PropTypes.any,
  fontWeight: PropTypes.number,
  fontFamily: PropTypes.number,
  className: PropTypes.any,
  title3: PropTypes.any,
  title4: PropTypes.any,
  title5: PropTypes.any,
  title6: PropTypes.any,
  title7: PropTypes.any,
};

export default CustomText;
